module.exports = __webpack_public_path__ + "static/media/loga.b7419603.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/loga.png
// module id = 85
// module chunks = 0